<template lang="pug">
  LoginComponent
    form(role="form" @submit.prevent="setPassword()")
      .field
        label(for="pspassword1") Password:
        input#pspassword1.form-field(type="password" v-model="password" placeholder="Enter password" required="")
      .field
        label(for='pspassword2') Repeat password:
        input#pspassword2.form-field(type="password" v-model="passwordRepeat" placeholder="Repeat password" required="")
      .field
        label(for="token") Token:
        input#token.form-field(type="text" v-model="key" required="" readonly="")
      slot
      .field(v-if="!passwordReset")
        label
          a.btn.btn-link.btn-link-cancel.pull-right(type="button" href="#/security/login" v-show="!passwordReset") cancel
        SspActionButton(type="submit" text="Set Password" :spinning="setting" :disabled="passwordReset || !password || password != passwordRepeat")
      .field(v-if="passwordReset")
          i.fa.fa-info-circle
          |  Your password has been set. You should now be able to log
          |                             in with your new password.
          a.btn.btn-link.btn-link-cancel.pull-right(type="button" href="#/security/login") back to log-in page
      .field.notice-box
        .alert.alert-danger(v-if="error") {{error}}
</template>

<script>
import LoginComponent from '@/components/ssp/LoginComponent'
import Security from '@/service/apis/Security'

export default {
  mounted() {
    this.$el.querySelector('#pspassword1').focus()
  },
  data: () => ({
    setting: false,
    passwordReset: false,
    password: null,
    passwordRepeat: null,
    error: null
  }),
  methods: {
    setPassword() {
      this.setting = true
      return Security.passwordReset(this.key, this.password)
        .then(() => {
          this.passwordReset = true
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.setting = false
        })
    }
  },
  computed: {
    key() {
      return this.$route.query.key
    }
  },
  components: {
    LoginComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/security/SetPassword.vue